import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbInsightObjectSchemaRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-object-schema',
	path: '/jira/servicedesk/insight/object-schemas/:objectSchemaId',
};
